export default __webpack_public_path__ + "static/media/HDTX_Minutes Summary of AGMS of June 30_2025.9cd79e19.pdf";